/**
 * Telefone do cadastro no formato E.164 (`+5584999998888`), que é o único que o
 * Chatwoot aceita no campo de telefone do contato (CHAT002-4230).
 *
 * O api-core grava o número normalizado com "+55", mas cadastro antigo pode ter
 * vindo como a pessoa digitou. Os casos brasileiros seguem os de
 * `formatPhoneForDisplay`; a diferença é o "+" explícito, que aqui vale para
 * qualquer país (lá, "+1 415 555 0100" seria lido como DDD 14).
 *
 * Devolve `null` quando não dá para ter certeza do número. Nesse caso o campo
 * fica de fora: o Chatwoot descartaria o valor de qualquer jeito, e o número
 * continua visível no atributo `telefone`, como a pessoa digitou.
 */
export function toE164(phone: string | null | undefined): string | null {
	if (!phone) return null;
	const digits = phone.replace(/\D/g, "");

	// Com o "+" explícito, o DDI já veio: vale para qualquer país. Precisa vir
	// antes da regra sem DDI, senão "+1 415 555 0100" (11 dígitos) viraria +55.
	if (phone.trim().startsWith("+")) {
		return digits.length >= 8 && digits.length <= 15 ? `+${digits}` : null;
	}

	// Com DDI do Brasil, sem o "+": 55 + DDD + 8 ou 9 dígitos.
	if (
		(digits.length === 12 || digits.length === 13) &&
		digits.startsWith("55")
	) {
		return `+${digits}`;
	}

	// Sem DDI: DDD + 8 ou 9 dígitos. Não pode começar com zero (DDD não começa).
	if ((digits.length === 10 || digits.length === 11) && digits[0] !== "0") {
		return `+55${digits}`;
	}

	return null;
}
